import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getLabelDetailList } from "../../store/Slice/labelDetailSlice";

const ThankYou = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [continueLoading, setContinueLoading] = React.useState(false);

  const { pagePath } = location.state || {};

  const { labelDetailData } = useSelector((state) => state.labelDetailList);

  const path = location.pathname.split("/")[1];

  const handleContinueClick = () => {
    setContinueLoading(true);

    setTimeout(() => {
      navigate("/");
      setContinueLoading(false);
    }, 2000);
  };

  React.useEffect(() => {
    if (pagePath === "/") {
      sessionStorage.removeItem("SameDayBookingId");
      sessionStorage.removeItem("checkAvailabilityClick");
      sessionStorage.removeItem("submitClick");
      sessionStorage.removeItem("bookNowButtonClick");
      sessionStorage.removeItem("scheduledTime");
      sessionStorage.removeItem("price");
      sessionStorage.removeItem("Tax");
      sessionStorage.removeItem("selectedServiceName");
      sessionStorage.removeItem("FinalPrice");
      sessionStorage.removeItem("CustomerName");
      sessionStorage.removeItem("SelectedExtras");
      sessionStorage.removeItem("CustomerEmail");
      sessionStorage.removeItem("Bathroom");
      sessionStorage.removeItem("FromTime");
      sessionStorage.removeItem("CustomerPhone");
      sessionStorage.removeItem("Date");
      sessionStorage.removeItem("Residence");
      sessionStorage.removeItem("ServiceId");
      sessionStorage.removeItem("UntillTime");
      sessionStorage.removeItem("Address");
      sessionStorage.removeItem("Bedroom");
      sessionStorage.removeItem("PayButtonClick");
      sessionStorage.removeItem("City");
      sessionStorage.removeItem("Unit");
      sessionStorage.removeItem("discountedHomeTotalAmount");
    } else if (pagePath === "/book-now") {
      sessionStorage.removeItem("bookSameDayBookingId");
      sessionStorage.removeItem("bookCheckAvailabilityClick");
      sessionStorage.removeItem("bookSubmitClick");
      sessionStorage.removeItem("bookPayButtonClick");
      sessionStorage.removeItem("bookedNowButtonClick");
      sessionStorage.removeItem("bookScheduledTime");
      sessionStorage.removeItem("bookPrice");
      sessionStorage.removeItem("bookTax");
      sessionStorage.removeItem("bookFinalPrice");
      sessionStorage.removeItem("bookCustomerName");
      sessionStorage.removeItem("bookCity");
      sessionStorage.removeItem("bookSelectedServiceName");
      sessionStorage.removeItem("PayBookNowButtonClick");
      sessionStorage.removeItem("bookSelectedExtras");
      sessionStorage.removeItem("bookCustomerEmail");
      sessionStorage.removeItem("bookBathroom");
      sessionStorage.removeItem("bookFromTime");
      sessionStorage.removeItem("bookCustomerPhone");
      sessionStorage.removeItem("bookDate");
      sessionStorage.removeItem("bookResidence");
      sessionStorage.removeItem("bookServiceId");
      sessionStorage.removeItem("bookUntillTime");
      sessionStorage.removeItem("bookAddress");
      sessionStorage.removeItem("bookBedroom");
      sessionStorage.removeItem("bookUnit");
      sessionStorage.removeItem("discountedBookNowTotalAmount");
    }
  }, [pagePath]);

  React.useEffect(() => {
    dispatch(getLabelDetailList({ vSlug: path }));
  }, [dispatch, path]);

  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
      return new Map(
        labelDetailData.data.map((item) => [item.vLabel, item.tText])
      );
    }
    return new Map();
  }, [labelDetailData]);

  const successMessageHeading =
    labelMap.get("LBL_THANK_YOU_SUCCESSFULLY_BOOKED_HEADING") || "";
  const successMessageDesc =
    labelMap.get("LBL_THANK_YOU_SUCCESSFULLY_BOOKED_DESCRIPTION") || "";

  const successForwardMessageDesc = labelMap.get(
    "LBL_THANK_YOU_SUCCESSFULLY_BOOKED_FORWARD_DESCRIPTION" || ""
  );

  return (
    <>
      <section
        className="howitwork-section book-howitwork-section pt-100"
        id="bookingavailability"
      >
        {/* <div className="container">
          <div className="row pb-50">
            <div className="col-lg-12 text-center">
              <span className="small-title">{singleVisitHeading}</span>
              <h2 className="main-title mb-0">{bookCleanerHeading}</h2>
            </div>
          </div>
        </div> */}
      </section>
      <section className="homecontact-section pb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-10 mx-auto">
              <div className="contactcard">
                <div className="getintouch-content text-center ps-0 pt-0">
                  <img
                    src="/assets/images/success.png"
                    className="success-img"
                    alt="success-img"
                    loading="lazy"
                  />
                  <h2 className="main-title">{successMessageHeading}</h2>
                  <p className="contactgray-para">{successMessageDesc}</p>
                  <p className="contactgray-para">
                    {successForwardMessageDesc}
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  {continueLoading ? (
                    <>
                      {" "}
                      <button
                        className="success-orangebtn"
                        type="button"
                        disabled
                      >
                        <span
                          className="spinner-border spinner-border-sm me-1 custom-spinner"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                    </>
                  ) : (
                    <button
                      type="submit"
                      className="success-orangebtn"
                      onClick={handleContinueClick}
                    >
                      Continue
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;
